import { up, useMediaQuery } from "@/hooks";
import { useSettings } from "@/store/settingStore";
import { ThemeLayout } from "#/enum";
import NavHorizontal from "./nav-horizontal";
import NavVertical from "./nav-vertical";
import { useLocation } from "react-router";

export default function Nav() {
	const { themeLayout } = useSettings();
	const isPc = useMediaQuery(up("md"));
	const location = useLocation();

	const blockedPaths = [
		"redirecting-to-payment-partner",
		"waiting-for-payment-confirmation",
		"payment/success",
		"payment/cancelled",
		"payment-error",
		"transfer-dashboards-success"
	];
	const isBlocked = blockedPaths.some(p => location.pathname.includes(p));

	if (themeLayout === ThemeLayout.Horizontal) return <NavHorizontal isBlocked={isBlocked} />;

	if (isPc) return <NavVertical isBlocked={isBlocked} />;
	return null;
}
